const TYPE = 'aggregationResultProcessor.range';
function process(type, result, query, context) {
  const {
    relationship
  } = context;
  const ref = `${relationship.ref}.agg`;
  return result?.buckets?.map(bucket => {
    const obj = {
      id: `${ref}-${bucket.key}`,
      type: 'aggResult',
      ref
    };
    const data = {
      key: bucket.key,
      value: bucket.count
    };
    obj.data = data;
    return obj;
  }) || [];
}
export default {
  TYPE,
  process
};